import { isNil } from "lodash";

export class CacheTable {
  constructor() {
    this._itemObject = {};
  }
  addItem(items, pagination) {
    this._itemObject[pagination.page] = items;
  }
  getItem(page) {
    let items = [];
    if (!isNil(page)) {
      return this._itemObject[page];
    } else {
      items = Object.keys(this._itemObject).reduce((acc, cur) => {
        return acc.concat(this._itemObject[cur]);
      }, []);
    }
    return items;
  }
  getItemArray(start, end) {
    let items = [];
    for (let index = start; index < end + 1; index++) {
      items = items.concat(this._itemObject[index]);
    }
    return items;
  }
  clear() {
    this._itemObject = {};
  }
}
